
import { Component, Vue, Prop } from 'vue-property-decorator'

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

const CallConfigModalProps = Vue.extend({
  props: {
    canCancel: Boolean,
    close: Boolean
  }
})

@Component
export default class CallConfigModal extends CallConfigModalProps {
  // @Prop(Boolean) close: boolean | false
  data () {
    return {
      isLoading: false,
      audioTest: true,
      showTimer: true,
      audioDevices: [],
      videoDevices: [],
      selectedVideoDeviceId: null,
      selectedAudioDeviceId: null,
      screenSharingStream: null,
      userMediaStream: null,
      sampleMediaStream: null,
      sampleOsc: null,
      sampleOscTrackId: null,
      sampleAudioContext: null,
      outputAudioContext: null,
      testAudioEl: null,
      activeVideoBorderRadius: '50%',
      activeVideoBorderRadiusBoolean: true,
      activeVideoBorderRadiusText: 'Rounded',
      threshold: 10,
      analyser: null,
      micAverage: 0,
      thresholdEl: null
    }
  }

  get isComponentModalActive () {
    return this.close
  }

  created () {
    this.$multiwatch(['selectedAudioDeviceId'], function () {
      this.updateAudio()
    })
    this.$multiwatch(['selectedVideoDeviceId'], async function () {
      this.updateVideo()
    })
    this.$multiwatch(['audioTest'], async function () {
      this.updateAudio()
    })
    this.$multiwatch(['activeVideoBorderRadiusBoolean'], async function () {
      this.activeVideoBorderRadius = this.activeVideoBorderRadiusBoolean ? '50%' : '3px'
      this.activeVideoBorderRadiusText = this.activeVideoBorderRadiusBoolean ? 'Rounded' : 'Square'
    })
    this.$multiwatch(['close'], function () {
      if (this.isComponentModalActive) {
        this.updateDeviceList()
      }
    })
  }

  mounted () {
    this.fillVariables()
    this.testAudioEl = new Audio()
    this.outputAudioContext = new (window.AudioContext || window.webkitAudioContext)()
    this.sampleAudioContext = new (window.AudioContext || window.webkitAudioContext)()
    this.sampleMediaStream = this.sampleAudioContext.createMediaStreamDestination()
    this.sampleOscTrackId = this.sampleMediaStream.stream.getAudioTracks()[0].id
    this.sampleOsc = this.sampleAudioContext.createOscillator()
    navigator.mediaDevices.ondevicechange = (event) => {
      this.updateDeviceList()
    }
    if (this.isComponentModalActive) {
      this.updateDeviceList()
    }
  }

  updated () {
    // this.init()
  }

  fillVariables () {
    var container = document.getElementById('thresholdContainer')
    this.thresholdEl = container.querySelector('.b-slider-fill')
    if (!this.thresholdEl) {
      setTimeout(this.fillVariables, 1000)
    }
  }

  async shareScreen () {
    this.screenSharingStream = await navigator.mediaDevices.getDisplayMedia({
      video: {
        cursor: 'always'
      },
      audio: false
    })
    await this.updateDeviceList()
    var tracks = this.screenSharingStream.getVideoTracks()
    if (tracks.length > 0) {
      this.selectedVideoDeviceId = tracks[0].id
    }
  }

  async stopShareScreen () {
    var tracks = this.screenSharingStream.getVideoTracks()
    tracks.forEach((track) => track.stop())
    this.screenSharingStream = null
    this.selectedVideoDeviceId = null
    this.updateDeviceList(true)
    // this.saveConfig()
  }

  async updateVideo () {
    var localVideo = document.getElementById('active-video-config')
    var tracks = this.userMediaStream.getVideoTracks()
    if (this.screenSharingStream) {
      var arr = this.screenSharingStream.getVideoTracks()
      tracks = this.videoDevices.concat(arr)
    }
    var trackIdx = tracks.findIndex(i => i.id === this.selectedVideoDeviceId)
    if (trackIdx > -1) {
      var stream = new MediaStream([tracks[trackIdx]])
      if (localVideo) {
        localVideo.srcObject = stream
      }
    } else {
      if (localVideo) {
        localVideo.srcObject = null
      }
    }
  }

  async updateDeviceList (needsToSaveConfig) {
    try {
      if (!this.userMediaStream) {
        try {
          this.userMediaStream = await navigator.mediaDevices.getUserMedia({ audio: true, video: true })
        } catch (e) {
          this.userMediaStream = new MediaStream([])
        }
      } else {
        try {
          var userMedia = await navigator.mediaDevices.getUserMedia({ audio: true, video: true })
          var newTracksList = userMedia.getTracks()
          var existingTracksList = this.userMediaStream.getTracks()
          newTracksList.forEach(track => {
            if (existingTracksList.findIndex(e => e.label === track.label) === -1) {
              this.userMediaStream.addTrack(track)
            }
          })
          existingTracksList.forEach(existingTrack => {
            if (newTracksList.findIndex(e => e.label === existingTrack.label) === -1) {
              this.userMediaStream.removeTrack(existingTrack)
            }
          })
        } catch (e) {
          this.userMediaStream = new MediaStream([])
        }
      }
      needsToSaveConfig = await this.updateVideoDevices() || needsToSaveConfig
      needsToSaveConfig = await this.updateAudioDevices() || needsToSaveConfig
      if (needsToSaveConfig) {
        this.saveConfig(false)
      }
    } catch (e) {
      console.error(e)
    }
  }

  async updateVideoDevices () {
    this.videoDevices = this.userMediaStream.getVideoTracks()
    if (this.screenSharingStream) {
      var arr = this.screenSharingStream.getVideoTracks()
      this.videoDevices = this.videoDevices.concat(arr)
    }
    var needsToSaveConfig = false
    if (this.selectedVideoDeviceId !== null) {
      var foundIdx = this.videoDevices.findIndex(e => e.id === this.selectedVideoDeviceId)
      if (foundIdx === -1) {
        this.selectedVideoDeviceId = null
        needsToSaveConfig = true
      }
    }
    if (this.selectedVideoDeviceId === null && this.videoDevices.length > 0) {
      if (this.videoDevices[0].readyState === 'live') {
        this.selectedVideoDeviceId = this.videoDevices[0].id
      }
    }
    return needsToSaveConfig
  }

  async updateAudio () {
    if (this.audioTest) {
      if (this.selectedAudioDeviceId === this.sampleOscTrackId) {
        this.createOscillator() // instantiate an oscillator
        this.testAudioEl.pause()
        this.disconnectMicAnalyser()
      } else {
        this.stopOscillator()
        this.connectAudioInput()
        /* if (!this.audioSource) {
          this.initMicAnalyser()
        }
        this.connectMicAnalyser() */
      }
    } else {
      if (this.sampleOsc.isPlaying) {
        this.stopOscillator()
      }
      this.testAudioEl.pause()
      this.disconnectMicAnalyser()
    }
  }

  async updateAudioDevices () {
    this.audioDevices = this.userMediaStream.getAudioTracks()
    this.audioDevices = this.audioDevices.concat([this.sampleMediaStream.stream.getAudioTracks()[0]])
    var needsToSaveConfig = false
    var foundIdx = this.audioDevices.findIndex(e => e.id === this.selectedAudioDeviceId)
    if (foundIdx === -1) {
      this.selectedAudioDeviceId = null
      needsToSaveConfig = true
    }
    if (this.selectedAudioDeviceId === null && this.audioDevices.length > 0) {
      this.selectedAudioDeviceId = this.audioDevices[0].id
      // needsToSaveConfig = true
    }
    return needsToSaveConfig
  }

  connectAudioInput () {
    var idx = this.audioDevices.findIndex(item => item.id === this.selectedAudioDeviceId)
    if (idx > -1) {
      this.audioStream = new MediaStream([this.audioDevices[idx]])
      this.testAudioEl.srcObject = this.audioStream
      this.testAudioEl.play()
    }
  }

  createOscillator () {
    this.sampleOsc = this.sampleAudioContext.createOscillator()
    this.sampleOsc.type = 'sine' // this is the default - also square, sawtooth, triangle
    this.sampleOsc.frequency.value = 100 // Hz
    this.sampleOsc.start()
    this.sampleOsc.isPlaying = true
    this.sampleOsc.connect(this.sampleMediaStream)
    this.sampleOsc.connect(this.sampleAudioContext.destination)
  }

  stopOscillator () {
    if (this.sampleOsc.isPlaying) {
      this.sampleOsc.stop()
      this.sampleOsc.isPlaying = false
      this.sampleOsc.disconnect(this.sampleMediaStream)
      this.sampleOsc.disconnect(this.sampleAudioContext.destination)
    }
  }

  saveConfig (closeModal) {
    var videoTracks = this.userMediaStream.getVideoTracks()
    if (this.screenSharingStream) {
      var arr = this.screenSharingStream.getVideoTracks()
      videoTracks = videoTracks.concat(arr)
    }
    var videoTrackIdx = videoTracks.findIndex(i => i.id === this.selectedVideoDeviceId)
    if (videoTrackIdx > -1) {
      this.$emit('selectedVideoDeviceTrack', videoTracks[videoTrackIdx])
    } else {
      this.$emit('selectedVideoDeviceTrack', null)
      // closeModal = false
    }
    var idx = this.audioDevices.findIndex(item => item.id === this.selectedAudioDeviceId)
    if (idx > -1) {
      this.$emit('selectedAudioDeviceTrack', this.audioDevices[idx])
      this.$emit('micThreshold', this.threshold)
      // TODO emit threshold
    } else {
      this.$emit('selectedAudioDeviceTrack', null)
      // closeModal = false
    }
    this.$emit('showTimer', this.showTimer)
    this.$emit('activeVideoBorderRadius', this.activeVideoBorderRadius)
    if (closeModal) {
      this.audioTest = false
      this.$emit('close')
    }
  }

  async initMicAnalyser (audioTrack) {
    // this.audioStream = new MediaStream([audioTrack])
    var audioContext = new AudioContext() // or webkitAudioContext
    this.audioSource = audioContext.createMediaStreamSource(this.audioStream)
    this.javascriptNode = audioContext.createScriptProcessor(2048, 1, 1) // TODO: this will be deprecated soon. should be replaced by AudioWorkletNode:
    this.analyser = audioContext.createAnalyser()
    this.analyser.smoothingTimeConstant = 0.3
    this.analyser.fftSize = 1024
    this.javascriptNode.onaudioprocess = this.audioAnalizerProcessor

    /* var volume = audioContext.createGain();
    source.connect(volume);
    volume.connect(audioContext.destination);
    volume.gain.value = 0;  //turn off the speakers */
  }

  async connectMicAnalyser () {
    this.audioSource.connect(this.analyser)
    this.analyser.connect(this.javascriptNode)
  }

  async disconnectMicAnalyser () {
    try {
      this.audioSource.disconnect(this.analyser)
      this.analyser.disconnect(this.javascriptNode)
      setTimeout(() => { this.thresholdEl.style.width = '0%' }, 100)
    } catch (e) {
      console.log('analyser is already disconnected')
    }
  }

  audioAnalizerProcessor () {
    var array = new Uint8Array(this.analyser.frequencyBinCount)
    this.analyser.getByteFrequencyData(array)
    var values = 0

    var length = array.length
    for (var i = 0; i < length; i++) {
      values += array[i]
    }
    var newValue = values / length
    if (newValue > this.threshold && this.micAverage < this.threshold) {
      this.micAverage = (this.micAverage + newValue) / 2
    } else {
      this.micAverage = (this.micAverage * 9 + newValue) / 10
    }
    this.thresholdEl.style.width = `${this.micAverage}%`
  }
}
